import { NError } from '@src/configs/const.config'
import { checkAuth } from '@libs/localStorage'
import { TResApi, TResApiErr } from '@src/configs/interface.config'
import { TDryRunBody, TEvaluatorRunResult, TTierPeek } from '@src/modules'
import { notification } from 'antd'
import { useMutation } from 'react-query'

import {
  peekTier,
  refreshRanking,
  runDailyRank,
  runWeeklyRank,
  runTierMonthly,
  runTierNightlyDelta,
} from '../apis/ops-admin'

const onErr = (error: TResApiErr) =>
  notification.error({ message: NError, description: error?.message })

const ok = (description: string) =>
  notification.success({ message: 'Thành công', description })

export const useRunTierMonthly = () => {
  const token = checkAuth()
  return useMutation((body: TDryRunBody) => runTierMonthly(body, token), {
    onSuccess: (_res: TResApi<TEvaluatorRunResult>, body) =>
      ok(body?.dryRun ? 'Đã chạy thử (dryRun) đánh giá hạng tháng.' : 'Đã chạy đánh giá hạng tháng.'),
    onError: onErr,
  })
}

export const useRunTierNightlyDelta = () => {
  const token = checkAuth()
  return useMutation((body: TDryRunBody) => runTierNightlyDelta(body, token), {
    onSuccess: (_res: TResApi<TEvaluatorRunResult>, body) =>
      ok(body?.dryRun ? 'Đã chạy thử (dryRun) cập nhật chỉ số đêm.' : 'Đã cập nhật chỉ số đêm.'),
    onError: onErr,
  })
}

export const usePeekTier = () => {
  const token = checkAuth()
  return useMutation((dealerId: number) => peekTier(dealerId, token), {
    onError: onErr,
  })
}

export const useRefreshRanking = () => {
  const token = checkAuth()
  return useMutation(() => refreshRanking(token), {
    onSuccess: () => ok('Đã làm mới bảng xếp hạng.'),
    onError: onErr,
  })
}

export const useRunDailyRank = () => {
  const token = checkAuth()
  return useMutation(() => runDailyRank(token), {
    onSuccess: () => ok('Đã dựng lại xếp hạng hôm qua.'),
    onError: onErr,
  })
}

export const useRunWeeklyRank = () => {
  const token = checkAuth()
  return useMutation(() => runWeeklyRank(token), {
    onSuccess: () => ok('Đã dựng lại xếp hạng tuần này.'),
    onError: onErr,
  })
}

export type { TTierPeek }
